module.exports = __webpack_public_path__ + "media/images/ecalls/03_reasons_opportunities-27175a244f37d24a283d237093a0f75d.png";